import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { AggregateService, GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems, PageEventArgs } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { isNumber } from 'highcharts';
import { distinctUntilChanged, debounceTime, tap, filter, switchMap, finalize } from 'rxjs/operators';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MenuFuncionService, GastoService, ComunidadService,ConsorcioService, TipoGastoService, ServicioGastoService, ProveedorService, TenantService } from '../../../../src/app/shared/services';
import { Comunidad, GridPageSettings, MenuFuncionCodes, SearchComunidadRequest, Consorcio, SearchConsorcioRequest, LocalStorageKeys, SearchTipoGastoRequest, Proveedor, SearchProveedorRequest, TenantFeatureFlags,
          SearchGastoRequest, TipoGasto, Gasto, SearchServicioGastoRequest, ServicioGasto } from '../../../../src/app/shared/model';
import { ExportMediaTypeConstants } from '../../shared/model';

@Component({
  selector: 'app-gastoLista',
  templateUrl: './gastoLista.component.html',
  styleUrls: ['./gastoLista.component.scss'],
  providers: [ AggregateService ]
})

export class GastoListaComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;
  total: number = 0;
  searchForm: FormGroup;

  tipoGastoList: TipoGasto[];
  comunidadList: Comunidad[];
  consorcioList: Consorcio[];
  servicioGastoList: ServicioGasto[];
  claseGastoList: any[];
  filteredProveedorList: Proveedor[] = [];

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  isTipoGastoSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isConsorcioSearching: boolean = false;
  isServicioGastoSearching: boolean = false;
  isStatisticsSearching: boolean = false;
  isProveedorAutoSearching: boolean = false;

  tenantFeatureFlags: TenantFeatureFlags;

  canEdit: boolean = false;
  canAdd: boolean = false;
  canView: boolean = false;
  canAnalizarDocs: boolean = false;
  canRecurrentes: boolean = false;

  public query: Query;
  public totales: any[];

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private service: GastoService,
    private comunidadService: ComunidadService,
    private consorcioService: ConsorcioService,
    private tipoGastoService: TipoGastoService,
    private proveedorService: ProveedorService,
    private tenantService: TenantService,
    private servicioGastoService: ServicioGastoService,
    private datePipe: DatePipe) {

  }

  ngOnInit(): void {
    this.menuService.checkMenuPadre(MenuFuncionCodes.GASTO).subscribe(data => {
      if (data != null && data.Success && data?.Result) {

        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canAdd = data.Result.some(x => x == MenuFuncionCodes.GASTO_ADD);
            this.canView = data.Result.some(x => x == MenuFuncionCodes.GASTO_LIST);
            this.canAnalizarDocs = data.Result.some(x => x == MenuFuncionCodes.GASTO_ANALISIS_DOCUMENTO_MASIVO);
            this.canRecurrentes = data.Result.some(x => x == MenuFuncionCodes.GASTO_RECURRENTES);

            if (this.canView){
              this.loadView();
            } else {
              this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
              this.router.navigate(['/']);
            }
          }
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.isValidating = false;
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.canView = true;

    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    this.buildForm();

    this.setQueryParams();
    this.data = new DataManager({
      url: this.service.getSearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });

    this.getSearchEstadisticas();

    this.getClasesGasto();
    this.getComunidades();
    this.getConsorcios();
    this.getTiposGasto();
    this.getServicios();
    this.getProveedoresAutocomplete();
  }

  isProcessing() {
    return (this.isSearching || this.isExporting);
  }

  onGridActionFailure(event: any): void {
    this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  onActionBegin(args: PageEventArgs) {
    if (args.requestType === 'paging' && !this.isSearching)
    {
      this.searchForm.get('gridPage')?.setValue(args.currentPage);
      this.sharedFunctions.setReporteFiltros("app-gastoLista", this.searchForm.getRawValue());
    }
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
        if (this.searchForm.get(formFieldName) != null && this.searchForm.get(formFieldName)?.value)
            this.searchForm.get(formFieldName)?.setValue(null);
    }
  }

  getClasesGasto() {
    this.claseGastoList = [
      { Id: 1, Nombre: "Ver Solo de " + this.sharedFunctions.getNombreMenuTenant("Comunidad") },
      { Id: 2, Nombre: "Ver Solo de " + this.sharedFunctions.getNombreMenuTenant("UnidadFuncional") }
    ];
  }

  getComunidades() {
    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      if (data != null)
        this.comunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getConsorcios() {
    if (!this.tenantFeatureFlags?.HabilitarGestionConsorcio)
     return false;

    var r = new SearchConsorcioRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isConsorcioSearching = true;

    this.consorcioService.search(r).subscribe(data => {
      this.isConsorcioSearching = false;
      if (data != null)
        this.consorcioList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isConsorcioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getTiposGasto() {
    var r = new SearchTipoGastoRequest(null, null, true, "Nombre", null, null, null, null, true);
    this.isTipoGastoSearching = true;

    this.tipoGastoService.search(r).subscribe(data => {
      this.isTipoGastoSearching = false;
      if (data != null)
        this.tipoGastoList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoGastoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getServicios() {
    var r = new SearchServicioGastoRequest(null, null, true, "Nombre", null, null, null, null, true);
    this.isServicioGastoSearching = true;

    this.servicioGastoService.search(r).subscribe(data => {
      this.isServicioGastoSearching = false;
      if (data != null)
        this.servicioGastoList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isServicioGastoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getProveedoresAutocomplete() {
    this.searchForm.get('Proveedor')?.valueChanges
      .pipe(
        filter(res => {
          return res && res !== null && res.length >= 3
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {
          this.filteredProveedorList = [];
          this.isProveedorAutoSearching = true;
        }),
        switchMap(value => this.proveedorService.search(new SearchProveedorRequest(null, null, true, "RazonSocial", null, !isNumber(parseInt(value)) ? value : null, isNumber(parseInt(value)) ? value : null, null, null, null, true))
          .pipe(
            finalize(() => {
              this.isProveedorAutoSearching = false;
            }),
          )
        )
      )
      .subscribe((data: any) => {
        if (data != null && data.result != null)
          this.filteredProveedorList = data.result;
        else
          this.filteredProveedorList = [];
        // (this.filteredProveedorList, 'lista proveedor')
      });
  }

  displayProveedor(proveedor: Proveedor): string {
    return proveedor && proveedor?.RazonSocial ? proveedor.RazonSocial : '';
  }

  buildForm() {
    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    this.searchForm = this.formBuilder.group({
      'Detalle': [null],
      'FechaGastoDesde': [null],
      'FechaGastoHasta': [null],
      'Proveedor': [null],
      'ConsorcioId': [cId],
      'ComunidadId': [null],
      'UnidadFuncionalCodigo': [null],
      'TipoGastoId': [null],
      'ServicioGastoId': [null],
      'ClaseGasto': [null],
      'VerSoloActivos': [true],
      'VerSoloPendientesLiquidacion': [false],
      'gridPage': [1]
    });

    var filtros = this.sharedFunctions.getReporteFiltros("app-gastoLista");

    if (filtros != null) {
      this.searchForm.patchValue(filtros);
      if (filtros.gridPage != null && filtros.gridPage > 0)
        this.pageSettings.currentPage = filtros.gridPage;
    }
  }

  onSearch() {
    this.searchForm.get('gridPage')?.setValue(1);
    this.sharedFunctions.setReporteFiltros("app-gastoLista", this.searchForm.getRawValue());

    this.setQueryParams();
    this.grid.refresh();

    this.getSearchEstadisticas();
  }

  getSearchEstadisticas() {
    var search = new SearchGastoRequest(null, null, null, "", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
    search = Object.assign(search, this.searchForm.value);

    this.isStatisticsSearching = true;
    this.service.getSearchEstadisticas(search).subscribe(data => {
      this.isStatisticsSearching = false;
      if (data.Success)
        this.totales = data.Result.Totales;
    },
    (err: HttpErrorResponse) => {
      this.isStatisticsSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "Detalle");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Detalle;
    else
      this.query.addParams("Detalle",this.searchForm.value.Detalle);

    index = this.query.params.findIndex(obj => obj.key === "FechaGastoDesde");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaGastoDesde,"yyyy-MM-dd");
    else
      this.query.addParams("FechaGastoDesde",this.datePipe.transform(this.searchForm.value.FechaGastoDesde,"yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaGastoHasta");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaGastoHasta,"yyyy-MM-dd");
    else
      this.query.addParams("FechaGastoHasta",this.datePipe.transform(this.searchForm.value.FechaGastoHasta,"yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "ProveedorId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Proveedor?.Id;
    else
      this.query.addParams("ProveedorId",this.searchForm.value.Proveedor?.Id);

    index = this.query.params.findIndex(obj => obj.key === "ComunidadId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ComunidadId;
    else
      this.query.addParams("ComunidadId",this.searchForm.value.ComunidadId);

    index = this.query.params.findIndex(obj => obj.key === "ConsorcioId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ConsorcioId;
    else
      this.query.addParams("ConsorcioId",this.searchForm.value.ConsorcioId);

    index = this.query.params.findIndex(obj => obj.key === "ClaseGasto");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ClaseGasto;
    else
      this.query.addParams("ClaseGasto",this.searchForm.value.ClaseGasto);

    index = this.query.params.findIndex(obj => obj.key === "UnidadFuncionalCodigo");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.UnidadFuncionalCodigo;
    else
      this.query.addParams("UnidadFuncionalCodigo",this.searchForm.value.UnidadFuncionalCodigo);

    index = this.query.params.findIndex(obj => obj.key === "TipoGastoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.TipoGastoId;
    else
      this.query.addParams("TipoGastoId",this.searchForm.value.TipoGastoId);

    index = this.query.params.findIndex(obj => obj.key === "ServicioGastoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ServicioGastoId;
    else
      this.query.addParams("ServicioGastoId",this.searchForm.value.ServicioGastoId);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloPendientesLiquidacion");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerSoloPendientesLiquidacion.toString();
    else
      this.query.addParams("VerSoloPendientesLiquidacion", this.searchForm.value.VerSoloPendientesLiquidacion.toString());

    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerSoloActivos.toString();
    else
      this.query.addParams("VerSoloActivos", this.searchForm.value.VerSoloActivos.toString());
  }

  add() {
    if (this.canAdd) {
      this.router.navigate(['gasto-edit', 0]);
    }
    else {
      this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
      this.router.navigate(['/']);
    }
  }

  edit(item: Gasto) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    this.router.navigate(['gasto-edit', item.Id]);
  }

  onExport() {
    var search = new SearchGastoRequest(null, null, null, "", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
    search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.service.exportSearch(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "Gastos_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  goToGastosRecurrentes() {
    if (this.canAdd && this.canRecurrentes) {
      this.router.navigate(['gastos-recurrentes']);
    }
    else {
      this.sharedFunctions.showMessage("No tiene permisos para realizar la operación", "Error");
    }
  }

  goToGastosDesdeDocumentos() {
    if (this.canAnalizarDocs && this.canAdd) {
      this.router.navigate(['gastos-desde-documentos']);
    }
    else {
      this.sharedFunctions.showMessage("No tiene permisos para realizar la operación", "Error");
    }
  }
}
